<template>
  <el-button 
    type="primary" 
    class="hydroware-add-button"
    value="add"
    v-bind="$attrs"
    v-on="$listeners">
    <i class="el-icon-plus"></i>
    <span v-if="!text">Add</span>
    <span v-if="text">{{text}}</span>
  </el-button>
</template>
<script>
export default {
    props: ['text'],
    methods: {
    }
  }
</script> 


// WEBPACK FOOTER //
// hydroware-add-button.vue?062a32d4